<template>
  <div>
    <div class="dropbox"  v-if="isInitial || isSaving">
      <input type="file" id="file" multiple :name="uploadFieldName" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files)" class="input-file">
      <div class="center" v-if="isInitial">
        <i class="icon-cloud-upload"></i>
        <p>Arraste seu arquivo aqui</p>
        <p>ou</p>
        <p>
          <button class="btn btn--success">Buscar no computador</button>
        </p>
      </div>
      <p class="center" v-if="isSaving">
        Salvando...
      </p>
    </div>

    <div v-if="isSuccess">
      <div class="image-list">
        <div v-for="image in uploadedFiles" :key="image" v-if="uploadedFiles.length" class="product-image">
          <img :src="image" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import notifier from '@/notifier'

  export default {
    data: () => ({
      uploadedFiles: [],
      currentStatus: null,
      uploadFieldName: 'images[]',
      statusInitial: 0,
      statusSaving: 1,
      statusSuccess: 2
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    mounted () {
      this.reset()
    },
    methods: {
      reset () {
        this.uploadedFiles = []
        const input = document.getElementById('file')
        if (input) {
          input.value = ''
        }
        this.currentStatus = this.statusInitial
      },
      validateFile (file) {
        if (file.type.split('/')[0] !== 'image') {
          notifier.error('Arquivo selecionado não é uma image', 'Erro')
          return false
        }

        return true
      },
      save (formData) {
        const files = formData.getAll('images[]')
        this.currentStatus = this.statusSaving
        this.uploadedFiles = []

        const processBatch = (i) => {
          if (i >= files.length) {
            this.$emit('file', this.uploadedFiles)
            this.currentStatus = this.statusSuccess
            return
          }

          const batchFormData = new FormData()
          files.slice(i, i + 2).forEach((f) => batchFormData.append('images[]', f))
          api.uploadImage(this.module.type, this.module.identifier, batchFormData)
            .then((r) => r.urls && this.uploadedFiles.push(...r.urls))
            .finally(() => processBatch(i + 2))
        }

        processBatch(0)
      },
      filesChange (fieldName, fileList) {
        const formData = new FormData()

        if (!fileList.length) {
          notifier.error('Nenhum arquivo selecionado.', 'Erro')
          return
        }

        Array
          .from(Array(fileList.length).keys())
          .map(x => {
            if (this.validateFile(fileList[x])) {
              formData.append(fieldName, fileList[x], fileList[x].name)
            }
          })

        this.save(formData)
      }
    },
    computed: {
      isInitial () {
        return this.currentStatus === this.statusInitial
      },
      isSaving () {
        return this.currentStatus === this.statusSaving
      },
      isSuccess () {
        return this.currentStatus === this.statusSuccess
      }
    }
  }
</script>

<style lang="sass" scoped>
  .dropbox
    outline: 2px dashed #d2cdcd
    background: #f9fdfd
    color: dimgray
    padding: 10px 10px
    min-height: 200px
    position: relative
    cursor: pointer

    .input-file
      opacity: 0
      width: 100%
      height: 200px
      position: absolute
      cursor: pointer
      z-index: 1

    .center
      font-size: 1.2em
      text-align: center
      padding: 50px 0

    .icon-cloud-upload
      font-size: 20px
      margin-bottom: 10px

  .icon-cross
    font-size: 8px
    cursor: pointer
    margin-top: 3px
    margin-left: 3px

  .image-list
    display: inline-block

    &:not(:first-child)
      margin-left: 6px
      background-color: #FFF

  .product-image
    display: inline-block
    border: 1px solid #333
    padding: 0 10px

    &:not(:first-child)
      margin-left: 10px

    img
      cursor: move
      max-width: 80px
</style>



// WEBPACK FOOTER //
// UploadImage.vue?e5ffe284